import { render, staticRenderFns } from "./SectionLive.vue?vue&type=template&id=79b58b0d&scoped=true&"
import script from "./SectionLive.vue?vue&type=script&lang=js&"
export * from "./SectionLive.vue?vue&type=script&lang=js&"
import style0 from "./SectionLive.vue?vue&type=style&index=0&id=79b58b0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b58b0d",
  null
  
)

export default component.exports